angular.module('jv.sendMessage.controller', [])
    .controller('jvSendMessageController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$q','$jobviteUrls','$timeout','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$q,$jobviteUrls,$timeout,jvHireBroadcastSVC) {
            jvHireBroadcastSVC.subscribe('showSendMessageModal', function(event, value) {
                $scope.action = 'sendMessage';
                $scope.validateCandidateDetails(value);
            });

            jvHireBroadcastSVC.subscribe('showSeekConsentModal', function(event, value) {
                $scope.action = 'seekConsent';
                $scope.validateCandidateDetails(value);
            });
            $scope.jvUrls = $jobviteUrls;
            var i18n;
            if($.isEmptyObject($scope.i18n)){
                //Candidate list page does not have i18n
                i18n = {
                    TO: 'To',
                    TEMPLATE: 'Template',
                    COMPANY: 'Company',
                    SUBJECT: 'Subject',
                    MESSAGE: 'Message',
                    UPLOAD_A_FILE : 'Upload File',
                    DROP_FILE : 'Or drop files here from your desktop to upload. Files shall not exceed 10MB',
                    ANONYMOUS_TOOLTIP_TEXT: 'Choose the Send Anonymously option if you do not want the candidate to see your name or email address. Note that the candidate will still be able to reply to your message.',
                    SEND_MESSAGE: 'Send Message'
                };
            }else{
                i18n = angular.copy($scope.i18n);
            }
            //Used to track if the user is on the candidate list page or details page 
            $scope.CandidateListPage = false;
            $scope.CandidateDetailsPage = false;
            
            // Modal Information
            $scope.modals = {
                sendMessage: {
                    show: false
                },
                sendMessageValidation:{
                    show: false
                },
                seekConsent: {
                    show: false
                }
            };
            //Setting up different modal configs//
            
        var getmodalConfig = function(action){
            var qsParams = {};
            if(JV.Person){
                qsParams.applicationEIds =  JV.Person.getSelectedAppIds();
            }else{
                qsParams.applicationEIds = $scope.appIds;
            }
                    
            switch (action) {
                case 'seekConsent':
                $scope.sendMessageModalConfig = {
                    resetModalOn:'modals.seekConsent.show',
                    to: {
                        label:i18n['TO'],
                        type: 'readOnlyLink',
                        data: {
                            type: 'link',
                            text : $scope.toList
                        },
                        responseKey: 'employees',
                    },
                    templates: {
                        type: 'dropDown',
                        get: {
                            url: $scope.jvUrls.jhire+'/action/application/template/ApplicationDataConsentForm?{0}'.format($.param(qsParams)),
                            transform: function(templateData){
                                return $scope.select2Options.setTemplates(templateData);
                            }
                        },
                        responseKey: 'templates',
                        label:i18n['TEMPLATE'],
                        optionText: 'title',
                        post:{
                            callBack: $scope.sendConsent,
                            button: {
                                label: i18n['SEND_MESSAGE'],
                                type: 'button',
                                classNames:['blue-btn','float-right'],
                                id:'send-msg-btn'
                            }
                        }
                    },
                    from: [
                    {
                        label: i18n['FROM'],
                        required: true,
                        errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        data: {
                                type: 'radio',
                                key:'sendMsgFrom',
                                name: 'fromList',
                                optionsValues:
                                [
                                    {
                                        label:_jvselfUser.fullName,
                                        checked:true
                                    },
                                    {
                                        label: i18n['SEND_ANONYMOUSLY'],
                                        tooltip: {
                                            show: true,
                                            text: i18n['ANONYMOUS_TOOLTIP_TEXT']
                                        }
                                    }
                                ]
                        }
                    }
                    ],
                    subject: {
                        required: true,
                        errorText:i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        label:i18n['SUBJECT']
                    },
                    message: {
                        required: true,
                        errorText:i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        label:i18n['MESSAGE']
                    }
                
                };
                
                return $scope.sendMessageModalConfig;
                
                break;
                
                case 'sendMessage':
            //	send Message modal config
                $scope.sendMessageModalConfig = {
                    resetModalOn:'modals.sendMessage.show',
                    to: {
                        label:i18n['TO'],
                        type: 'readOnlyLink',
                        data: {
                            type: 'link',
                            text : $scope.toList
                        },
                        responseKey: 'employees',
                    },
                    templates: {
                        type: 'dropDown',
                        get: {
                            url: $scope.jvUrls.jhire+'/action/application/template/SendMessageToCandidate?{0}'.format($.param(qsParams)),
                            transform: function(templateData){
                                return $scope.select2Options.setTemplates(templateData);
                            }
                        },
                        responseKey: 'templates',
                        label:i18n['TEMPLATE'],
                        optionText: 'title',
                        post:{
                            callBack: $scope.sendMessage,
                            button: {
                                label: i18n['SEND_MESSAGE'],
                                type: 'button',
                                classNames:['blue-btn','float-right'],
                                id:'send-msg-btn'
                            }
                        }
                    },
                    from: [
                    {
                        label: i18n['FROM'],
                        required: true,
                        errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        data: {
                                type: 'radio',
                                key:'sendMsgFrom',
                                name: 'fromList',
                                optionsValues:
                                [
                                    {
                                        label:_jvselfUser.fullName,
                                        checked:true
                                    },
                                    {
                                        label: i18n['SEND_ANONYMOUSLY'],
                                        tooltip: {
                                            show: true,
                                            text: i18n['ANONYMOUS_TOOLTIP_TEXT']
                                        }
                                    }
                                ]
                        }
                    }
                    ],
                    fileUploader: true,
                    subject: {
                        required: true,
                        errorText:i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        label:i18n['SUBJECT']
                    },
                    message: {
                        required: true,
                        errorText:i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                        label:i18n['MESSAGE']
                    }
                
                };//end config object
                
                if (action === 'sendMessage' && typeof properties !== 'undefined' && properties.personalEmailTemplatesEnabled) {
                    $scope.sendMessageModalConfig.templateType = [];
                    $scope.sendMessageModalConfig.templateType.push({
                        label: i18n['TEMPLATES'],
                        required: true,
                        name: 'templateList',
                        onchange: toggleTemplates,
                        data: {
                            type: 'radio',
                            key: 'sendMsgTemplate',
                            optionsValues: [
                                {
                                    label: i18n['COMPANY_TEMPLATES'],
                                    checked: true
                                },
                                {
                                    label: i18n['MY_TEMPLATES']
                                }
                            ]
                        }
                    });
                }
                return $scope.sendMessageModalConfig;
            }
        };

        var toggleTemplates = function(radioObject){
            var directiveScope = this;
            
            if (directiveScope.modalList[radioObject] === i18n['MY_TEMPLATES']) {
                    //keep copy of company templates
                    if(!$scope.companyTemplates){
                        $scope.companyTemplates = angular.copy(directiveScope.msgDataItem);
                    }
                    //setting the subject and message to empty since there is no default
                    directiveScope.msgDataItem.subject = '';
                    directiveScope.msgDataItem.body = '';
                    directiveScope.msgDataItem.template = '';
                    //reload select2
                    directiveScope.modalList.templates.type = 'ajax';
                    directiveScope.modalList.templates.get.url = $scope.jvUrls.admin+'/action/myAccount/userEmailTemplate/list';
                    directiveScope.modalList.customEmailTemplateSelectConfig = {
                        ajax: {
                            type: 'GET',
                            data: function (term, page) {
                                return {
                                    page: page - 1,
                                    keywords: term
                                };
                            },
                            results: function(data, page){
                                var pageSize = 10;
                                var more = (page * pageSize) < data.count;
                                return {
                                    results: data.userEmailTemplates, more: more
                                };
                            }
                        }
                    };
            } else {
                directiveScope.modalList.templates.type = '';
                $timeout(function(){
                    directiveScope.msgDataItem = angular.copy($scope.companyTemplates);
                },300);
            }
        };

        //Function to set up form template config. Making sure this is fired after we get workflowEId back from get appdetails call 
        var setupFormTemplateConfig = function(action){
                //FormTemplateConfig
                $scope.formTemplateConfig = getmodalConfig(action);
        };

        //Used to show the move modal
        $scope.showModals = function(modal,skipConfigSetup){
            if(!skipConfigSetup){
                setupFormTemplateConfig(modal);
            }
            TemplateLoader.load(modal).then(function(){
                    $scope.modals[modal].show = true;
                    if(JV.Person){
                        JV.Person.Global.grid.removeLoadingState();
                    }
            });
        };

        //Used to hide all the modals on the page
        $scope.hideModals = function(){
            angular.forEach($scope.modals, function(val, key) {
                 $scope.modals[key].show = false;
            });
            if(JV.Person){
                JV.Person.resetValues();
            }
        };

        $scope.templates = TemplateLoader.register({
            sendMessage: '/jhire/modules/candidates/modals/sendMessage.html',
            sendMessageValidation: '/jhire/modules/candidates/modals/sendMessageValidation.html',
            seekConsent: '/jhire/modules/candidates/modals/seekConsentMessage.html'
        });
        
        $scope.validateCandidateDetails = function(data){
            var postData = {};
            postData.action = 'sendMessage';
            if(data){
                postData.data = data.appIds;
                $scope.appIds = postData.data;
                $scope.isMultipleApplicationsSelected = postData.data.length>1 ? true : false;
            }else{
                postData.data = JV.Person.getSelectedAppIds();
                $scope.isMultipleApplicationsSelected = postData.data.length>1 ? true : false;
            }

            jvCandidatesService.validateCandidateDetails(postData,function(response){
                if(response && response.status === 200){
                    var validationResult = $scope.validationResult = response.data;
                    var validAgencyApplicationCount =  response.data.validAgencyApplicationCount,
                    validApplicationCount = response.data.validApplicationCount;
                    validationResult.unAuthorizedApplicationCountLink = '';
                    validationResult.unAuthorizedApplicationMsg = '';
                    validationResult.validApplicationCountLink = '';
                    validationResult.validAgencyApplicationCountLink = '';
                    validationResult.invalidApplicationCountLink = '';
                    validationResult.invalidAgencyApplicationCountLink = '';

                    if(response.data.validApplicationIds){
                        if(response.data.validApplicationIds.length === 0){
                            $scope.showModals('sendMessageValidation',true);
                            return false;
                        }
                    }
                    var candidateName;

                    if(JV.Person && JV.Person.getSelectedAppIds().length==1){
                        //only one candidate selected. Hence we show name 
                        candidateName = JV.Person.getSelectedCandidateName();
                        if(validApplicationCount ===1){
                            $scope.toList += '<span class="block">'+candidateName+'</span>';
                        }else{
                            if(validAgencyApplicationCount ===1){
                                $scope.toList += '<span class="block">' + candidateName;
                                if(scope.action !== 'seekConsent'){
                                    $scope.toList+= ' '+i18n['JV_SENDMESSAGE_CONTROLLER_AGENCY_WILL_BE_CC_ED']+'</span>';        							
                                }
                            }
                        }
                    }else{
                        //More than one candidate selected. We wont show name here only count. 
                        if(validationResult.validApplicationCount){
                            validationResult.validApplicationCountLink = validationResult.validApplicationCount +' '+ i18n['CANDIDATES_COMMON'];
                        }
                        if(validationResult.validAgencyApplicationCount) {
                            if($scope.action !== 'seekConsent'){
                                validationResult.agencyCopied = i18n['CANDIDATES_AGENCY_COPIED'];
                            }else{
                                validationResult.agencyCopied = "";
                            }
                            validationResult.commonAnd = i18n['COMMON_AND'];
                            validationResult.validAgencyApplicationCountLink = validationResult.validAgencyApplicationCount +' '+ i18n['CANDIDATES_AGENCY_COMMON'];
                        }
                    }
                    if(validationResult.invalidApplicationCount || validationResult.invalidAgencyApplicationCount) {
                        if(validationResult.invalidApplicationCount){
                            validationResult.invalidApplicationCountLink = validationResult.invalidApplicationCount +' '+ i18n['CANDIDATES_COMMON'];
                        }
                        if(validationResult.invalidAgencyApplicationCount) {
                            validationResult.commonAnd = i18n['COMMON_AND'];
                            validationResult.invalidAgencyApplicationCountLink = validationResult.invalidAgencyApplicationCount +' '+ i18n['CANDIDATES_AGENCY_COMMON'];
                        }
                        validationResult.skipMissingEmail = i18n['CANDIDATES_MISSING_EMAIL'];
                    }
                    if(validationResult.unAuthorizedApplicationCount) {
                        validationResult.unAuthorizedApplicationCountLink = validationResult.unAuthorizedApplicationCount +' '+ i18n['CANDIDATES_COMMON'];
                        validationResult.unAuthorizedApplicationMsg = i18n['CANDIDATES_SKIP_MSG'];
                    }
                    $scope.validApplicationIds = response.data.validApplicationIds;
                    if(JV.Person){
                        JV.Person.Global.grid.showLoadingState();
                    }
                    $scope.showModals($scope.action);

                }
            });
        };
        
        $scope.sendConsent = function(modalData){
            $scope.hideModals();
            if(JV.Person){
                JV.Person.Global.grid.showLoadingState();
            }
            modalData.sendMsgFrom = modalData.sendMsgFrom.replace(/\s+/g, '');
            var data = {
                content: modalData.msgDataItem.body,
                subject: modalData.msgDataItem.subject,
                entityIdList: $scope.validApplicationIds,
                sendAnonymously: modalData.sendMsgFrom =='SendAnonymously' ? true : false
            };
            if(modalData && modalData.msgDataItem && modalData.msgDataItem.template){
                data['locale'] = modalData.msgDataItem.template['locale'];
            }
            $scope.flags.loading = true;
            jvCandidatesService.seekConsent(data, function(response) {
                if (response && response.status === 200) {
                     $rootScope.$broadcast('sendMessageSuccess', true);
                    if(JV.Person){
                        JV.Person.Global.grid.removeLoadingState();
                        JV.Person.resetAfterActionUpdates();
                        var confirmationText = ($scope.validApplicationIds.length =='1') ? i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_1_CANDIDATE'] : i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_0_CANDIDATES'].format($scope.validApplicationIds.length);
                        JV.Util.showMessage(confirmationText);
                    }
                }
            }, function(fail) {
                $scope.flags.loading = false;
            });
        };

        //send message POST
        $scope.sendMessage = function(modalData) {
            $scope.hideModals();
            if(JV.Person){
                JV.Person.Global.grid.showLoadingState();
            }
            var attachments = modalData.msgDataItem.attachments;
            var attachmentList = [];
            angular.forEach(attachments,function(attachment,key){
                attachmentList.push(attachment.resourceInfo.eid);
            });
            //trim text
            modalData.sendMsgFrom = modalData.sendMsgFrom.replace(/\s+/g, '');
            var data = {
                    content: modalData.msgDataItem.body,
                    subject: modalData.msgDataItem.subject,
                    entityIdList: $scope.validApplicationIds,
                    attachmentList: attachmentList,
                    sendAnonymously: modalData.sendMsgFrom =='SendAnonymously' ? true : false
                };
            $scope.flags.loading = true;

            /*BE expects locale to be sent to determine language for Email header/footer*/
            if(modalData && modalData.msgDataItem && modalData.msgDataItem.template){
                data['locale'] = modalData.msgDataItem.template['locale'];
            }
            jvCandidatesService.sendMessage(data, function(response) {
                if (response && response.status === 200) {
                     $rootScope.$broadcast('sendMessageSuccess', true);
                    if(JV.Person){
                        JV.Person.Global.grid.removeLoadingState();
                        JV.Person.resetAfterActionUpdates();
                        var confirmationText = ($scope.validApplicationIds.length =='1') ? i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_1_CANDIDATE'] : i18n['JV_SENDMESSAGE_CONTROLLER_MESSAGE_WAS_SENT_SUCCESSFULLY_TO_0_CANDIDATES'].format($scope.validApplicationIds.length);
                        JV.Util.showMessage(confirmationText);
                    }
                }
            }, function(fail) {
                $scope.flags.loading = false;
            });
        };

    }
]);